<template>
    <div class="modal-shopping-voucher">
      <dass-dialog
        v-if="showModalShoppingVoucher"
        title=" " 
        size="medium"
        ref="ModalShoppingVoucher"
        class="dass-dialog--shopping-voucher"
        @close="closeModal"
      >
        <template #content>            
            <div class="dass-title">
              <h3>{{ this.$t('dass.requestRefund') }} </h3>
            </div>
            <div class="dass-subtitle" v-html="getGeneralSettings?.SCO_MSG_CUPOM">              
            </div> 
            <div class="dass-actions">
                <div class="dass-card-content-container" v-if="percentageBonus != 0">
                    <div class="dass-card-content">
                       <span>{{ $t('dass.bonusCoupon') }}</span>
                       <span v-if="percentageBonus > 0">{{  + percentageBonus + '% '  }}</span>        
                       <span v-else-if="percentageBonus"> {{   percentageBonus  }}</span>                                    
                    </div>
                    <dass-button :class="this.isSafari ? `dass-button-tertiary-${this.brandName}` : 'button'" @click="acceptShoppingVoucher" type="button" variant="tertiary">
                        {{ $t('dass.receiveDiscountCoupon') }}
                    </dass-button>
                </div>
                <dass-button :class="this.isSafari ? `dass-button-secondary-${this.brandName}` : ''" @click="proceedToRefund" type="button" variant="secondary">
                  {{ $t('dass.ProceedToRefund') }}
                </dass-button>
            </div>
            <div class="dass-message-refund">
              <small v-html="getGeneralSettings?.SCO_MSG_CUPOM_INST"></small>
            </div>             
        </template>
      </dass-dialog>
    </div>
  </template>
  
<script>
import { mapGetters, mapActions } from 'vuex'
import { useIsSafari } from '@/composables/useIsSafari'
import moment from 'moment'
  
export default {
  name: 'ModalShoppingVoucher',
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },        
  },
  emits: ['closeModal', 'acceptShoppingVoucher'],  
  setup() {
    const { isSafari, brandName } = useIsSafari()
    
    return {
      isSafari,
      brandName
    }
  },
  computed: {
    ...mapGetters('generalSettings', ['getGeneralSettings']),    
    ...mapGetters('wallet', ['getCouponsCampaign', 'getWalletHistoric', 'getDiscountCoupons', 'getTotalTransactions']),
    ...mapGetters('protocols', ['getProtocols']),
    showModalShoppingVoucher() {      
      return this.showModal
    },
    totalBalance() {
      return this.getTotalTransactions[0]?.VALOR_VALE_COMPRAS_CREDITADO - this.getTotalTransactions[0]?.VALOR_VALE_COMPRAS_DEBITADO || 0
    },        
    percentageBonus() {      
      if (this.totalBalance <= 0 || !this.getGeneralSettings?.TIC_CODIGO) return 0;
      
      const existProtocolNoCoupon = this.getWalletHistoric.find(item => item.VCO_IDVTEX && !item.TCM_CODIGO);      
      if (!existProtocolNoCoupon) return 0;
            
      const currentCampaign = this.getCouponsCampaign.find(coupon => coupon.TIC_CODIGO == this.getGeneralSettings?.TIC_CODIGO);
      const bonusValue = currentCampaign?.TIC_DESCONTO ?? currentCampaign?.TIC_NOME ?? 0;
      
      const qtdConfigured = this.getGeneralSettings?.SCO_QTD_CUPOM || 1;
      const recentCoupons = this.getDiscountCoupons.slice(-qtdConfigured);       
      
      if (recentCoupons.length < qtdConfigured) {
        return bonusValue;
      }
      
      const oldestOfRecent = recentCoupons[0]; 
      const newestOfRecent = recentCoupons[recentCoupons.length - 1]; 
      
      const today = moment();     
      
      if (!oldestOfRecent?.TCM_DTCRIACAO) return 0; 
      
      const dateOldestCoupon = moment(oldestOfRecent.TCM_DTCRIACAO);           
      const diffDays = today.diff(dateOldestCoupon, 'days');
      const dayConfigValid = this.getGeneralSettings?.SCO_VAL_CUPOM || 0;     

      const isOldestInactive = oldestOfRecent?.TCC_STATUS != 'Ativo';
      const isNewestInactive = newestOfRecent?.TCC_STATUS != 'Ativo';

      if (diffDays >= dayConfigValid && (isOldestInactive || isNewestInactive)) {
        return bonusValue;
      }      
      return 0;
    }
  },
  methods: {
    closeModal() {          
      this.$emit('closeModal')      
    }, 
    proceedToRefund() { 
      this.$emit('proceedToRefund')      
    },
    acceptShoppingVoucher() {
      const {PRT_ID, MOT_ID} = this.getWalletHistoric.find(item => item.VCO_IDVTEX && !item.TCM_CODIGO);             
      this.$emit('acceptShoppingVoucher', PRT_ID, MOT_ID)
    },    
  },    
}
</script>
  
<style lang="scss">
  .modal-shopping-voucher {
    .dass-dialog--close {      
      padding: 0 !important;
      height: 50px;
      width: 50px;
    }
    .dass-dialog--header {
      padding-top: 0 !important;
      padding-right: 0 !important;
    }
    .dass-dialog--control {
      border-radius: 10px !important;
    }    
    .dass-dialog--contents {
      padding-top: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-right: 1rem;
      margin-left: 1rem;
    }    
    .dass-subtitle {  
      text-transform: none;         
      padding-bottom: var(--space);
    }
    label {
      font-weight: bold;
    }
    .dass-message-refund {
        text-transform: none;
        margin-bottom: var(--space__0-5x);
        margin-top: var(--space__0-5x);
        line-height: normal !important;
    }
    .dass-actions {
      margin-top: var(--space__1-5x);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      row-gap: var(--space);
      .dass-card-content-container {
        border: 1px solid #E9E9E9;
        border-radius: var(--theme-border-radius);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: auto;        
        .dass-card-content {     
          padding: var(--space);     
          text-transform: uppercase;
          display: flex;
          flex-direction: column;
          align-items: center; 
          row-gap: var(--space__0-5x);  
        }
      } 
      .dass-button__secondary {
        width: 100%;
      }
    }
  }
  .theme-umbro {
    .dass-dialog--control {
      background-color: var(--theme-white) !important;
      color: var(--color-default-umbro) !important;
    }
    .dass-link {
      color: var(--theme-white) !important;
    }
    .dass-button__tertiary {
      color: var(--theme-white) !important;
      text-decoration: none !important;
    }
    .dass-button__primary {
      background-color: var(--theme-white) !important;
      color: var(--theme-color) !important;
      transition: background-color 0.3s ease;
      &:hover {
        background-color: #758396;
      }
    }
  }
</style>
  